export const GET_ALL_USERS_LIST = "GET_ALL_USERS_LIST";
export const GET_USER_DETAILS = "GET_USER_DETAILS";
export const GET_ALL_BLACKLIST_DATA = "GET_ALL_BLACKLIST_DATA";
export const GET_BLACKLIST_DETAILS = "GET_BLACKLIST_DETAILS";
export const GET_ALL_IP_LIST = "GET_ALL_IP_LIST";
export const GET_RESOURCE_LIST_DATA = "GET_RESOURCE_LIST_DATA";
export const GET_RESOURCE_DETAILS_DATA = "GET_RESOURCE_DETAILS_DATA";
export const GET_CATEGORY_LIST_DATA = "GET_CATEGORY_LIST_DATA";
export const GET_FEATURE_LIST_DATA = "GET_FEATURE_LIST_DATA";
export const GET_FEATURE_DETAILS_DATA = "GET_FEATURE_DETAILS_DATA";
export const GET_ALL_PAGES_DATA = "GET_ALL_PAGES_DATA";
export const ADD_NEW_SUBSCRIPTION = "ADD_NEW_SUBSCRIPTION";
export const GET_ALL_INSURANCES = "GET_ALL_INSURANCES";
export const GET_SUBSCRIPTIONS_BY_ID = "GET_SUBSCRIPTIONS_BY_ID";
export const GET_ALL_PLANS_BY_ID = "GET_ALL_PLANS_BY_ID";
export const ADD_NEW_PLAN = "ADD_NEW_PLAN";
export const GET_INSURANCE_BY_ID = "GET_INSURANCE_BY_ID";
export const GET_SUBSCRIPTION_DETAILS = "GET_SUBSCRIPTION_DETAILS";
export const GET_PALN_DETAILS = "GET_PALN_DETAILS";
export const GET_FAQS = "GET_FAQS";
export const GET_FAQ_DETAILS = "GET_FAQ_DETAILS";
export const GET_INSURANCE_CMS_DATA = "GET_INSURANCE_CMS_DATA";
export const GET_MEMBERSHIP_CMS_DATA = "GET_MEMBERSHIP_CMS_DATA";
export const GET_USERS_CATEGORIES = "GET_USERS_CATEGORIES";
export const GET_NOTIFICATION_DETAILS = "GET_NOTIFICATION_DETAILS";
export const GET_INVITE_FRIEND_DETAILS = "GET_INVITE_FRIEND_DETAILS";
export const GET_MEMBER_BENEFITS_HERO_CMS_DATA = "GET_MEMBER_BENEFITS_HERO_CMS_DATA";
export const GET_MEMBER_BENEFITS_CMS_DATA = "GET_MEMBER_BENEFITS_CMS_DATA";
